import { HorizontalSliderScrollbar } from "components/elements/horizontalSliderScrollbar";
import { motion, useMotionValue } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import "./section-horizontal-card-slide-v2.scss";

const MotionDiv: any = motion.div;

const SectionHorizontalCardSlideV2: React.FC = ({ title, text, cards }) => {

  const containerRef = useRef<HTMLDivElement | null>(null);
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const scrollBarRef = useRef<HTMLDivElement | null>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [sliderWidth, setSliderWidth] = useState(0);
  const thumbWidth = 48;
  const x = useMotionValue(0);

  useEffect(() => {
    const container = containerRef.current;
    const slider = sliderRef.current;
    if (!container || !slider) return;
    const measure = () => {
      setContainerWidth(container.clientWidth);
      setSliderWidth(slider.scrollWidth);
      const minX = container.clientWidth - slider.scrollWidth;
      // Clamp x within new bounds
      x.set(Math.min(0, Math.max(minX, x.get())));
    };
    const ro = new ResizeObserver(measure);
    ro.observe(container);
    ro.observe(slider);
    measure();
    return () => ro.disconnect();
  }, [x]);

  const clampX = (next: number) => {
    const min = containerWidth - sliderWidth;
    return Math.min(0, Math.max(min, next));
  };

  const onWheel = (e: React.WheelEvent) => {
    // Prefer horizontal delta when present, fall back to vertical
    let delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    if (delta === 0) return;
    // Firefox may report line/page deltas; normalize to pixels
    // deltaMode: 0=pixel, 1=line, 2=page
    // @ts-ignore
    const mode: number = e.deltaMode ?? 0;
    if (mode === 1) delta *= 16; // approx line height
    else if (mode === 2) delta *= containerWidth; // page
    e.preventDefault();
    x.set(clampX(x.get() - delta));
  };

  return (
    <section className="section-horizontal-card-slide-v2">
      <div className="container-v2">
        <div className="section-horizontal-card-slide-v2--content">
          {title && <h2 className="section-horizontal-card-slide-v2--title">{title}</h2>}
          {text?.childrenMarkdownRemark?.[0]?.html && <div className="section-horizontal-card-slide-v2--text" dangerouslySetInnerHTML={{ __html: text.childrenMarkdownRemark[0].html }} />}
        </div>

        <div>
          <div ref={containerRef} className="section-horizontal-card-slide-v2--patient-journey-container" onWheel={onWheel}>
            <MotionDiv
              ref={sliderRef}
              className="cards-track"
              style={{ x, willChange: "transform" as any }}
              drag="x"
              dragMomentum={false}
              dragElastic={false}
              dragConstraints={{
                left: containerWidth - sliderWidth,
                right: 0,
              }}
            >
              <div className="card first">
                {title && <h2 className="card-title">{title}</h2>}
                {text?.childrenMarkdownRemark?.[0]?.html && <div className="card-text" dangerouslySetInnerHTML={{ __html: text.childrenMarkdownRemark[0].html }} />}
              </div>
              {cards?.length > 0 && cards.map((card: any) => (
                <div key={card.id} className="card first">
                  {card?.title && <h2 className="card-title">{card.title}</h2>}
                  {card?.subTitle && <h3 className="card-sub-title">{card.subTitle}</h3>}
                  {card.text?.childrenMarkdownRemark?.[0]?.html && <div className="card-text" dangerouslySetInnerHTML={{ __html: card.text.childrenMarkdownRemark[0].html }} />}
                </div>
              ))}
              <span className="track-spacer" aria-hidden="true" />
            </MotionDiv>

          </div>
          {sliderWidth > containerWidth + 2 && (
            <HorizontalSliderScrollbar
              containerWidth={containerWidth}
              sliderWidth={sliderWidth}
              thumbWidth={thumbWidth}
              x={x}
              scrollBarRef={scrollBarRef}
            />
          )}
        </div>
      </div>



    </section>
  );
};

export default SectionHorizontalCardSlideV2;
